import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetTour, useUpdateTour } from "@/hooks/tours";
import { CreateTour, Tour } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(tours)/tours/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading: tourLoading, data: model } = useGetTour(id);

  useSyncLoading(tourLoading || !model);

  if (tourLoading || !model) return <DomainUpsertLoadingList />;

  return <Edit model={model} />;
}

function Edit({ model }: { model: Tour }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateTour({
    onSuccess: (tour) => {
      navigate({
        to: "/tours",
        params: { id: tour.id.toString() },
      });
    },
  });

  const update = async (guide: CreateTour) => {
    await mutateAsync({ id: model.id, ...guide });
  };
  return <Form model={model} onUpsert={update} />;
}
